// example response from PRC WS - used for mock response when running in our test env
import {mockResponse} from '../responseHelper'

const prcWsResponse = {
    "studentReadingRecordId": 860459,
    "challengeLevel": "5-6",
    "challengeYear": 2018,
    "totalBooks": 30,
    "maxChoiceBooks": 5,
    "readingLevels": "5-6",
    "progress": 0,
    "books": [
        {
            "bookId": 12345,
            "title": "Long walk, The",
            "author": "Greenwood, Kerry",
            "publisherName": "Hodder Headline Australia Pty Ltd",
            "yearPublished": 2004,
            "isbn": "9780733617669",
            "readingLevel": "7-9",
            "annotations": "In 1931, a family's mother falls ill and their only hope is to reach their father working on the Great Ocean Road. The children set off on a long journey, with only a pram filled with their belongings, meeting all types of people on the way.",
            "pageCount": 0,
            "positionInSeries": 0,
            "averageRating": 0,
            "challengeYear": 2001,
            "difficultRead": false,
            "imagePresent": true,
            "imageCoverUrl": "/prc/system/getWebFile.html?taxonomy=BOOKLIST_COVER&amp;filename=9780733617669.jpg",
            "categories": "Historical fiction",
            "isNew": "F",
            "type": "PRC",
            "isOfficial": "T"
        }, {
            "bookId": 123,
            "title": "Fall, The (The seventh tower 1)",
            "shortTitle": "Fall, The",
            "author": "Nix, Garth",
            "publisherName": "Scholastic Australia",
            "yearPublished": 2000,
            "isbn": "9780439176828",
            "readingLevel": "7-9",
            "annotations": "In a land where sunstones provide the only light, Tal tries to save his family from social oblivion.",
            "pageCount": 0,
            "positionInSeries": 0,
            "averageRating": 0,
            "challengeYear": 2001,
            "difficultRead": false,
            "imagePresent": true,
            "imageCoverUrl": "/prc/system/getWebFile.html?taxonomy=BOOKLIST_COVER&amp;filename=9780439176828.jpg",
            "categories": "Fantasy",
            "isNew": "F",
            "type": "PRC",
            "isOfficial": "T"
        }, {
            "bookId": 11111,
            "title": "The x files goblins",
            "author": "Charles Grant",
            "yearPublished": 0,
            "pageCount": 0,
            "positionInSeries": 0,
            "averageRating": 0,
            "challengeYear": 0,
            "difficultRead": false,
            "imagePresent": false,
            "imageCoverUrl": "No Image available",
            "isNew": "F",
            "type": "CHOICE",
            "isOfficial": "F"
        },
    ]
};

export default function (options) {
    if (options.method === 'POST') {
        prcWsResponse.books.unshift(JSON.parse(options.body))
    }
    if (options.method === 'DELETE') {
        prcWsResponse.books = prcWsResponse.books.filter(b => b.bookId !== options.bookId)
    }
    return Promise.resolve(mockResponse('application/json', prcWsResponse))
}
